// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"bVzlkcdITJzMVmbH2xIhT"};